var map = {
	"./globalLoadConfig.json": "./src/tests/mock-responses/globalLoadConfig.json",
	"./menuCreateMenuGroupFailed.json": "./src/tests/mock-responses/menuCreateMenuGroupFailed.json",
	"./menuFetchCatalogue.json": "./src/tests/mock-responses/menuFetchCatalogue.json",
	"./menuFetchCatalogueFailed.json": "./src/tests/mock-responses/menuFetchCatalogueFailed.json",
	"./menuFetchDepartments.json": "./src/tests/mock-responses/menuFetchDepartments.json",
	"./menuFetchMenu.json": "./src/tests/mock-responses/menuFetchMenu.json",
	"./menuFetchMenuGroupListFailed.json": "./src/tests/mock-responses/menuFetchMenuGroupListFailed.json",
	"./menuFetchStoreDetail.json": "./src/tests/mock-responses/menuFetchStoreDetail.json",
	"./menuFetchStoreList.json": "./src/tests/mock-responses/menuFetchStoreList.json",
	"./menuUpdateItemFailed.json": "./src/tests/mock-responses/menuUpdateItemFailed.json",
	"./menuUpdateMenuGroupFailed.json": "./src/tests/mock-responses/menuUpdateMenuGroupFailed.json",
	"./menuUploadItemPhoto.json": "./src/tests/mock-responses/menuUploadItemPhoto.json",
	"./menuUploadItemPhotoFailed.json": "./src/tests/mock-responses/menuUploadItemPhotoFailed.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/tests/mock-responses sync recursive ^\\.\\/.*\\.json$";